import React from 'react';

import OcFabButton from './OcFabButton';

export interface OcFabWidgetTriggerProps {
    usePreviewButton: boolean;
    onClick: () => void;
}

export const OcFabWidgetTrigger: React.FC<OcFabWidgetTriggerProps> = ({
    usePreviewButton,
    onClick,
}) => {
    if (usePreviewButton) {
        return (
            <button type="button" onClick={onClick} className="btn btn-primary">
                Preview AI Assistant
            </button>
        );
    }

    return <OcFabButton onClick={onClick} />;
};

